import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useInnerBlocks } from 'gutenberg/utils'
import { renderRichText } from '../../../gutenberg/helpers'
import useIsInViewport from '../../util/useIsInViewport'
import ReactPlayer from 'react-player'

import { HomeBlockWrapper } from './custom.styled'

const HomeStage = ({
  isEditor,
  children,
  title,
  background,
  anchor,
  image,
  cssClass,
  videoType,
  video,
}) => {
  const { InnerBlocks } = useInnerBlocks(children, 'div', {
    className: `home-stage__content`,
  })
  const ref = useRef()
  const inViewport = useIsInViewport(ref)
  const [videoUrl, setVideoUrl] = useState(null)

  //set video full url string
  const setVideoUrlString = video => {
    switch (videoType) {
      case 'youtube':
        setVideoUrl(
          `https://www.youtube.com/watch?v=${video}&controls=0&loop=1`
        )
        break
      case 'vimeo':
        setVideoUrl(`https://vimeo.com/${video}`)
        break
      default:
        setVideoUrl(video)
    }
  }

  //update video
  useEffect(() => {
    setVideoUrlString(video)
  }, [videoType, video])

  return (
    <HomeBlockWrapper
      {...(anchor && { id: anchor })}
      className={['home-stage', cssClass, 'alignfull']
        .filter(item => item)
        .join(' ')}
      background={background}
      isEditor={isEditor}
      ref={ref}
    >
      {image?.url && (
        <img className={'home-stage__image'} src={image.url} alt="image" />
      )}
      {title && (
        <div className="is-root-container">
          <div
            className={`title data-scroll fade-in${
              inViewport ? ' data-scroll-in' : ''
            }`}
          >
            {renderRichText(title, 'h1', {})}
          </div>
        </div>
      )}
      {video && videoUrl && (
        <div className={'player-wrapper'}>
          <ReactPlayer
            className="react-player"
            width={'auto'}
            height={'auto'}
            url={videoUrl}
            playing={true}
            loop={true}
            controls={false}
            playsinline={true}
            volume={0}
            muted={true}
          />
        </div>
      )}
      <div
        className={`is-root-container data-scroll fade-in delay${
          inViewport ? ' data-scroll-in' : ''
        }`}
      >
        {InnerBlocks}
      </div>
    </HomeBlockWrapper>
  )
}

HomeStage.propTypes = {
  isMobile: PropTypes.bool,
  isEditor: PropTypes.bool,
  title: PropTypes.any,
  children: PropTypes.any,
  background: PropTypes.string,
  anchor: PropTypes.string,
  image: PropTypes.object,
  cssClass: PropTypes.string,
  videoType: PropTypes.string,
  video: PropTypes.string,
}

export default HomeStage
